import { render, staticRenderFns } from "./AddTagModal.vue?vue&type=template&id=0d7baaa8&scoped=true"
import script from "./AddTagModal.vue?vue&type=script&lang=js"
export * from "./AddTagModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7baaa8",
  null
  
)

export default component.exports